import { Component, Inject } from '@angular/core';
import {
    PurchaseOrderApprovalStatusEnumId,
    PURCHASE_ORDER_APPROVAL_STATUS_ENUM
} from '@classictechsolutions/hubapi-transpiled-enums';
import { IPurchaseOrderMappedItem, PurchaseOrdersLogicService } from '@app/logic/purchase-orders';
import { IPurchaseOrdersLogicService } from '@app/logic/purchase-orders/interfaces/i.purchase-orders.logic.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from '@app/core/services/toast/toast.service';
import { CurrentUserService } from '@app/core/authentication/current.user';
import { BaseDialogFormViewDirective } from '@app/shared/base-views/base-dialog-form-view.directive';
import { IPurchaseOrderDto } from '@app/logic/purchase-orders/interfaces/i.purchase-order.dto';
import { ComputedProperty } from '@app/shared/utils/computed-property.util';
import { Observable, take } from 'rxjs';

interface ReviewSubmitArgs {
    approvalStatus: PurchaseOrderApprovalStatusEnumId;
    comments: string;
}

interface IData {
    submit: (args: ReviewSubmitArgs) => Observable<IPurchaseOrderDto | void>;
}

@Component({
    selector: 'cb-review-manual-order-dialog',
    templateUrl: './review-purchase-order-dialog.component.html',
    styleUrls: ['./review-purchase-order-dialog.component.scss'],
    standalone: false
})
export class ReviewPurchaseOrderDialogComponent extends BaseDialogFormViewDirective<
    IPurchaseOrderDto,
    IPurchaseOrderMappedItem,
    IPurchaseOrdersLogicService
> {
    public static readonly MIN_WIDTH = '40%';

    public approvalStatus: PurchaseOrderApprovalStatusEnumId;
    public readonly PURCHASE_ORDER_APPROVAL_STATUS_ENUM = PURCHASE_ORDER_APPROVAL_STATUS_ENUM;
    public comments = '';

    public commentsRequired = new ComputedProperty(
        () => this.approvalStatus === PURCHASE_ORDER_APPROVAL_STATUS_ENUM.Rejected
    );

    constructor(
        public readonly dialogRef: MatDialogRef<ReviewPurchaseOrderDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: IData,
        @Inject(ToastService) private readonly toastService: ToastService,
        @Inject(CurrentUserService) public readonly currentUser: CurrentUserService,
        @Inject(PurchaseOrdersLogicService)
        public readonly purchaseOrderLogic: PurchaseOrdersLogicService
    ) {
        super(dialogRef, toastService);
    }

    public submit(): void {
        if (this.approvalStatus == null) {
            return;
        }

        this.data
            .submit({
                approvalStatus: this.approvalStatus,
                comments: this.comments
            })
            .pipe(take(1))
            .subscribe({ next: this.handleNext });
    }
}
